import { Icon } from '@chakra-ui/react';

export default function SFExclamationMarkTriangleOutlined(props) {
  return (
    <Icon
      width='18px'
      height={4}
      viewBox='0 0 18 16'
      xmlns='http://www.w3.org/2000/svg'
      fill='currentColor'
      {...props}
    >
      <path d='M2.94531 15.7422C1.61719 15.7422 0.8125 14.8203 0.8125 13.625C0.8125 13.2578 0.90625 12.8828 1.11719 12.5312L7.17969 1.96875C7.57812 1.25781 8.28125 0.898438 9 0.898438C9.71875 0.898438 10.4141 1.25781 10.8203 1.96875L16.8828 12.5312C17.0781 12.875 17.1875 13.2578 17.1875 13.625C17.1875 14.8203 16.3828 15.7422 15.0547 15.7422H2.94531ZM2.95312 14.5156H15.0391C15.5781 14.5156 15.9219 14.0938 15.9219 13.6172C15.9219 13.4688 15.8828 13.2891 15.7969 13.125L9.74219 2.5625C9.57812 2.27344 9.28906 2.14844 9 2.14844C8.71094 2.14844 8.41406 2.27344 8.25 2.5625L2.19531 13.1172C2.10938 13.2812 2.07812 13.4688 2.07812 13.6172C2.07812 14.0938 2.40625 14.5156 2.95312 14.5156ZM9 10.4766C8.60938 10.4766 8.39062 10.25 8.38281 9.85156L8.28125 5.72656C8.27344 5.32812 8.57031 5.03906 8.99219 5.03906C9.40625 5.03906 9.71875 5.33594 9.71094 5.73438L9.60156 9.85156C9.59375 10.2578 9.375 10.4766 9 10.4766ZM9 13.0156C8.54688 13.0156 8.15625 12.6484 8.15625 12.2031C8.15625 11.75 8.53906 11.3906 9 11.3906C9.46094 11.3906 9.84375 11.7422 9.84375 12.2031C9.84375 12.6562 9.45312 13.0156 9 13.0156Z' />
    </Icon>
  );
}
